import React, { useContext } from "react"
import ProductCard from "../../../../components/ProductCard"
import SearchBar from "../../../../components/SearchBar"
import { TOPIC_TYPE } from "../../../../shared/constants"
import PRODUCTS from "../../../../graphql/products.graphql"
import { Query } from "react-apollo"
import { debounce } from "throttle-debounce"
import { Waypoint } from "react-waypoint"
import ContentCard from "../../../../components/ContentCard"
import AppContext from "../../../../shared/AppContext"
import "./style.scss"
import { Redirect } from "react-router"

export default function RelatedProducts(props) {
  const { trackEvent } = useContext(AppContext)
  let { topic } = props
  let filters = {}
  const type = topic.type || ""

  if (type.toLowerCase() === TOPIC_TYPE.VENDOR) {
    filters.vendor = topic.name
  } else if (type.toLowerCase() === TOPIC_TYPE.SECTOR) {
    filters.sector = topic.name
  }

  return (
    <Query query={PRODUCTS} variables={{ filters }}>
      {({ loading, error, data, refetch, variables, fetchMore }) => {
        if (error) {
          return <Redirect to="Not-Found" />
        }

        const searchProducts = (e) => {
          let keyword = e.target.value
          trackEvent("Related Product Search", {
            page: topic.name,
            filters: {
              ...variables.filters,
              keyword,
            },
          })

          return refetch({
            ...variables,
            filters: {
              ...variables.filters,
              keyword,
            },
          })
        }

        const loadMoreOnScroll = (e) =>
          fetchMore({
            variables: {
              starting_after_products:
                data.products && data.products.length > 0
                  ? data.products[data.products.length - 1].id
                  : null,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev
              return Object.assign({}, prev, {
                products: [...prev.products, ...fetchMoreResult.products],
              })
            },
          })

        const debounceSearch = debounce(450, searchProducts)

        return (
          <section className="related-products">
            <ContentCard>
              <SearchBar
                placeholder="Search"
                classes={["border", "rounded"]}
                onChange={(e) => {
                  e.persist()
                  debounceSearch(e)
                }}
              />
            </ContentCard>
            {data.products && data.products.length ? (
              <ul className="related-products-list">
                {data.products.map((product) => (
                  <li className="related-products-list-item" key={product.id}>
                    <ProductCard
                      {...product}
                      productQuery={{ query: PRODUCTS, variables }}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              <p className="related-products-no-results">No Results</p>
            )}
            {!loading && (
              <div className="loading-more-reports">
                <Waypoint onEnter={loadMoreOnScroll} />
              </div>
            )}
          </section>
        )
      }}
    </Query>
  )
}
